import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import JobCard from './JobCard';
import Illustration from '../../Illustration';
import { selectProjectList } from '../../../store/selectors';

const styles = theme => ({
  root: {
  },

});

const JobCards = ({ classes, projects }) => {
  return (
    <div className={classes.root}>
      {projects.length > 0 &&
        projects.map((project, i) => {
          return <JobCard key={i} project={project} />
        })
      }
      {projects.length === 0 &&
        <Illustration
          title="Hmm, no Jobs..."
          imgKey="customer_survey_amber"
          explainerText="Either you've not entered any or your filter had no results."
          addItemText="Enter a new Job by clicking the 'Floating Action Button' at top right."
        />
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return ({
    projects: selectProjectList(state)
  })
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(JobCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/JobCards.jsx